<template>
  <div class="page">
    <van-dropdown-menu  :disabled="loading">
      <van-dropdown-item v-model="parkingLotId" :options="parkingLotOptions" />
    </van-dropdown-menu>

    <div>
      <div class="tips">此停车场共{{parkingSpots.length}}个车位，请点击进行操作:</div>
      
      <van-pull-refresh @refresh="loadAllSpots" v-model="loading" :disabled="disableRefresh">
        <van-row style="padding-bottom: 100px;">
          <van-col v-for="spot in parkingSpots" :key="spot.id" span="8">
            <div :class="{spot: true, 'is-parking' : spot.parking}" @click="selectSpot(spot)">
              <div class="spot-title">
                <div class="spot-name">{{spot.name}}</div>
                <div class="spot-parking">{{spot.parking ? '计费中' : ''}}</div>
              </div>
              <div class="spot-dev">
                <van-tag v-if="spot.dev" type="danger" size="medium">调试模式</van-tag>
                <van-tag v-else plain size="medium">非调试模式</van-tag>
              </div>
              <div class="w100p">
                <div v-if="!spot.query" class="dev-loading"><van-loading size="12px">查询DTU...</van-loading></div>
                <div v-else-if="spot.query==1" class="spot-device">
                  <span>
                    <van-icon size="20" name="bulb-o" :color="spot.status.light==LIGHT_ON ? '#0865f4' : 'gray'" style="font-weight: bold"/>
                  </span>
                  <span>
                    <van-icon size="20" name="lock" :color="spot.status.devLock==LOCKED ? '#0865f4' : '#ccc'"/>
                  </span>
                  <span>
                    <van-icon size="20" name="logistics" :color="spot.status.isOccupied == OCCUPIED ? '#0865f4' : '#ccc'" style="font-weight: bold"/>
                  </span>
                  <span>
                    <van-icon v-if="spot.status.position=='25'" name="back-top" color="#0865f4" style="font-weight: bold"/>
                    <van-icon v-else-if="spot.status.position=='27'" name="sort" color="#0865f4" style="font-weight: bold" />
                    <van-icon v-else-if="spot.status.position=='26'" name="down" color="#0865f4" />
                  </span>
                </div>
                <div v-else class="dev-error">未知设备状态</div>
              </div>
            </div>
          </van-col>
        </van-row>
      </van-pull-refresh>
      <van-action-sheet v-model="showAction" :actions="spotActions" cancel-text="取消" :description="'请选择对'+spot?.name+'车位的操作:'" close-on-click-action @select="selectedAction" />
    </div>
  </div>
</template>
<script>
import { ActionSheet, Button, Col, DropdownItem, DropdownMenu, Field, Icon, Loading, Picker, Popup, PullRefresh, Row, Tag } from 'vant';

const LIGHT_ON = 11, LOCKED = 16, OCCUPIED = 22;

export default {
  components: {
    [Popup.name] : Popup,
    [Field.name] : Field,
    [Row.name] : Row,
    [Col.name] : Col,
    [Tag.name] : Tag,
    [Icon.name] : Icon,
    [Picker.name ] : Picker,
    [Loading.name] : Loading,
    [Button.name] : Button,
    [PullRefresh.name] : PullRefresh,
    [ActionSheet.name] : ActionSheet,
    [DropdownMenu.name] : DropdownMenu,
    [DropdownItem.name] : DropdownItem
  },
  data() {
    return {
      LIGHT_ON,
      LOCKED,
      OCCUPIED,
      parkingLotId: 0,
      parkingLots: [],
      spot: null,
      loading: false,
      parkingSpots: [],
      showAction: false
    };
  },
  methods: {
    selectSpot(spot){
      this.spot = spot;
      this.showAction = true;
    },
    selectedAction(action) {
      if (this.spot) {
        if (action.key == 'REFRESH') {
          this.loadSpotStatus(this.spot.id);
        } else if (action.key == 'UN_DEV_MODE' || action.key == 'DEV_MODE') {
          this.$http.post('/parking/set_dev', {dev: action.key == 'DEV_MODE', parkingSpotId: this.spot.id}).then(() => this.loadSpotStatus(this.spot.id))
        } else if (action.key == 'UNLOCK' || action.key == 'LOCK') {
          this.$http.post('/parking/device_lock', {lock: action.key == 'LOCK', parkingSpotId: this.spot.id}).then(() => this.loadSpotStatus(this.spot.id))
        } else if (action.key == 'CLOSE_ORDER') {
          this.$http.post('/parking/close_order', {parkingSpotId: this.spot.id}).then(() => this.loadSpotStatus(this.spot.id))
        }
      }
    },
    setSpot(index, spot) {
        this.parkingSpots.splice(index, 1, spot);
        if (this.spot && spot.id == this.spot.id) {
          this.spot = {...spot};
        }
    },
    loadSpotStatus(parkingSpotId) {
      const index = this.parkingSpots.findIndex(x => x.id==parkingSpotId);
      if (index>-1) {
        let spot = this.parkingSpots[index];
        spot.query = 0;
        this.setSpot(index, spot);
        return this.$http.get('/parking/manage_spot_status', {parkingSpotId}).then(info => {
          if (info && info.status) {
            spot = {...spot, ...info};
            spot.query = 1;
            this.setSpot(index, spot);
          } else {
            if (info) {
              spot = {...spot, ...info};
            }
            spot.query = 2;
            this.setSpot(index, spot);
          }
          return spot;
        }).catch(() => {
          spot.query = 0;
          this.setSpot(index, spot);
          return spot;
        })
      }
      return Promise.resolve();
    },
    async loadAllSpotsStatus() {
      const parkingLotId = this.parkingLotId;
      for (let i = 0; i < this.parkingSpots.length; i++) {
        const spot = this.parkingSpots[i];
        if (parkingLotId === this.parkingLotId) {
          await this.loadSpotStatus(spot.id);
        } else {
          // 停车场已切换，立即终止退出
          break;
        }
      }


      // load spot status one by one
      /*
      const load = index => {
        if (index < this.parkingSpots.length - 1) {
          this.loadSpotStatus(this.parkingSpots[index].id).finally(()=>load(index+1));
        } else if (index < this.parkingSpots.length) {
          this.loadSpotStatus(this.parkingSpots[index].id);
        }
      }
      load(0);*/
    },
    loadAllSpots(parkingLotId){
      const id = parkingLotId || this.parkingLotId;
      this.loading = true;
      this.$http.get('/parking/manage_spots', {parkingLotId : id}).then(list =>{
        this.parkingSpots = list.map(x => ({...x, parkingLotId: id}));
        this.loadAllSpotsStatus();
      }).finally(()=>this.loading=false);
    }
  },
  mounted() {
    this.loading = true;
    this.$http.get('/parking/spots_parking_lots').then(list => {
      this.parkingLots = list;
      if (list && list.length > 0) {
        let index = list.findIndex(x => x.id == 17563);
        index = index > -1 ? index : 0;
        this.parkingLotId = list[index].id;
      }
    }).finally(()=>this.loading=false);
  },
  watch:{
    parkingLotId(id) {
      this.loadAllSpots(id);
    }
  },
  computed: {
    spotActions(){
      const actions = [{name: "刷新此车位状态", key: "REFRESH", loading: !this.spot || !this.spot.query}];
      if (this.spot) {
        if (this.spot.dev) {
          actions.push({name: '退出调试模式', key : 'UN_DEV_MODE'})
        } else {
          actions.push({name: '进入调试模式', key : 'DEV_MODE'})
        }
        if (this.spot.status) {
          if (this.spot.status.devLock==LOCKED) {
            actions.push({name: '解锁关灯', key : 'UNLOCK'})
          } else {
            actions.push({name: '上锁亮灯', key : 'LOCK'})
          }
        } 
        
        if (this.spot.parking) {
          actions.push({name: '关闭计费', key : 'CLOSE_ORDER', color: '#ee0a24'})
        }
      }
      return actions;
    },
    parkingLotOptions() {
      return this.parkingLots.map(({id, name}) => ({text: name, value: id}));
    },
    disableRefresh : {
      get : function(){
        return this.parkingSpots.map(x => !x.query).some(x=>x) || this.loading
      },
      set: function(v) {
        this.loading = v;
      }
    }
  }
}
</script>
<style lang="less" scoped>
.tips{
  margin: 10px;
  color: #999;
  font-size: 14px;
}
.spot {
  background-color: white;
  height: 100px;
  margin: 6px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px;
  justify-content: space-between;
  box-shadow: 1px 1px 5px rgba(100, 100, 100, 0.3);
  overflow: hidden;
}

.spot-name {
  font-weight: bold;
  font-size: 24px;
}
.spot-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.spot-parking {
  font-size: 14px;
  color: #0865f4;
  font-weight: bold;
}
.is-parking {
  background-color: #ecf1f6;
}
.spot-device {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.dev-loading {
  font-size: 12px;
  color: gray;
}
.dev-error {
  font-size: 12px;
  color: red;
  text-align: center;
}
</style>